import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  ListItem,
  ListItemText,
  makeStyles,
} from '@material-ui/core';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
import { useSnackbar } from 'notistack';

import DialogHeader from 'components/DialogHeader';
import { useAppDispatch, useAppSelector } from 'store';
import {
  atendimentosSelector,
  fetchAtendimentosIniciados,
  fixarAtendimento,
} from 'store/reducers/atendimentos';
import { getUrlParams } from 'utils/getUrlParams';

interface ModalInatividadeAtendenteProps {
  atendimentoId: string;
  open: boolean;
  onClose: () => void;
}

const useStyles = makeStyles(({ spacing, palette }) => ({
  titleHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing(1),
    fontSize: 16,
    color:
      palette.type === 'light' ? palette.warning.dark : palette.warning.light,
  },
}));

export default function ModalInatividadeAtendente({
  atendimentoId,
  open,
  onClose,
}: ModalInatividadeAtendenteProps) {
  const classes = useStyles();
  const dispatch = useAppDispatch();

  const { loadingFixarAtendimento, showModalAlertaInatividade } =
    useAppSelector(atendimentosSelector);

  const { enqueueSnackbar } = useSnackbar();

  const { orderInitiatedBy } = getUrlParams();

  const handleFixarAtendimento = () => {
    dispatch(fixarAtendimento(atendimentoId))
      .then(() => {
        dispatch(fetchAtendimentosIniciados({ orderBy: orderInitiatedBy }));
      })
      .catch(() => {
        enqueueSnackbar('Erro ao fixar o atendimento');
      })
      .finally(() => onClose());
  };

  return (
    <Dialog
      open={open && showModalAlertaInatividade}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
    >
      <DialogHeader
        title={
          <span className={classes.titleHeader}>
            <ReportProblemOutlinedIcon />
            Aviso de inatividade
          </span>
        }
      />

      <DialogContent>
        <ListItem style={{ paddingLeft: 0 }}>
          <ListItemText
            primary="Este atendimento será transferido para a fila em alguns minutos."
            primaryTypographyProps={{
              variant: 'body2',
              style: { marginBottom: 8 },
            }}
            secondary="Para continuar, envie uma mensagem ou fixe na sua lista de atendimentos."
            secondaryTypographyProps={{
              variant: 'body2',
              color: 'textPrimary',
              style: { fontWeight: 'bold' },
            }}
          />
        </ListItem>
      </DialogContent>

      <DialogActions>
        <Button variant="outlined" onClick={onClose}>
          Entendi
        </Button>
        <Button
          variant="contained"
          color="primary"
          type="submit"
          onClick={handleFixarAtendimento}
          disabled={loadingFixarAtendimento}
        >
          Fixar na lista
        </Button>
      </DialogActions>
    </Dialog>
  );
}
